<ng-template id="reportgeneral" let-toolbar="toolbar" let-module="module">
  <reportgeneral [toolbar]="toolbar" [module]="module" (onFilterTemplate)="onFilter($event)"></reportgeneral>
</ng-template>

<div class="h-100 w-100" [gov-editor]="app.datasources.projectplans" (onFilterTemplate)="onFilter($event)"
  (onWorkItemDetailsTemplate)="onWorkItemDetails($event)"></div>